import React, { useEffect } from 'react';
import { ArrowLeft } from 'lucide-react';
import type { CurrentPage } from '../../App';

export interface IwiPlanProps {
  onNavigate: (page: CurrentPage, associatedId?: string) => void;
  floorPlanId?: string;
}

const IwiPlan: React.FC<IwiPlanProps> = ({ onNavigate, floorPlanId }) => {
  useEffect(() => {
    if (floorPlanId) {
      console.log('IwiPlan received floorPlanId:', floorPlanId);
      // Logic to load/use IWI plan for this floorPlanId
    }
  }, [floorPlanId]);

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Header */}
      <header
        className="bg-gray-100 border-b border-gray-200 shadow-sm sticky top-0 z-40 flex-shrink-0"
      >
        <div className="w-full px-4 py-3 flex items-center justify-between">
          <button
            onClick={() => onNavigate({ page: 'retrofit' })}
            title="Back to Retrofit Hub"
            className="p-2 rounded-md text-gray-700 hover:bg-gray-200 transition-colors"
          >
            <ArrowLeft size={22} />
          </button>
          <h1 className="text-lg font-semibold text-gray-800">
            IWI Diagram Plan Form
          </h1>
          <div className="w-10"></div> {/* Spacer */}
        </div>
      </header>

      {/* Content - TODO: Add form fields based on PDF */}
      <main className="flex-1 p-4 sm:p-6 lg:p-8">
        <h2>IWI Plan</h2>
        {floorPlanId && <p>Plan for Floor Plan ID: {floorPlanId}</p>}
        <p>Details about Internal Wall Insulation...</p>
        <button onClick={() => onNavigate({ page: 'retrofit' })} className="mt-4 px-4 py-2 bg-gray-200 rounded">
          Back to Retrofit
        </button>
      </main>
    </div>
  );
};

export default IwiPlan; 